<template>
  <div class="topbar">
    <KeywordFilter :lookup="'users/fetch'" :limit="usersLimit" />
    <div class="topbar__cell">
      <div v-if="isLandlord()" class="buttonset buttonset--left buttonset--fillable buttonset--padding-left">
        <router-link
          :to="{ name: 'import-users' }"
          class="btn btn--secondary"
        >{{ $t('users.import_user') }}</router-link>
      </div>
      <counters>
        <template slot="total">{{users.total}}</template>
      </counters>
      <div class="buttonset">
        <router-link
          class="btn btn--secondary"
          :to="{ name: 'export-users' }"
        >{{ $t('top_bar.generate_report') }}</router-link>&nbsp;
        <!--<router-link class="btn btn--main" :to="{ name: 'add-user' }">{{ $t('top_bar.add_new_user') }}</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Counters from 'common/Counters';
import Messages from 'common/Messages';
import KeywordFilter from './KeywordFilter';

export default {
  components: {
    KeywordFilter,
    Counters,
    Messages,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    users: 'landlord/users/users',
    usersLimit: 'landlord/users/limit',
  }),
};
</script>

<style lang="scss" scoped>
.messages {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/Topbar.vue